const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Iter 127 — bolds the searched words inside titles and previews so it's
// obvious why each result matched. Matches the whole phrase and each word.
export function kbHighlight(text, query) {
  const src = String(text || "");
  const q = String(query || "").trim();
  if (!q) return src;
  const words = q.split(/\s+/).filter((w) => w.length > 1);
  const terms = [...new Set([q, ...words])].filter(Boolean).sort((a, b) => b.length - a.length);
  if (!terms.length) return src;
  const lower = new Set(terms.map((t) => t.toLowerCase()));
  return src.split(new RegExp(`(${terms.map(esc).join("|")})`, "ig")).map((part, i) =>
    lower.has(part.toLowerCase())
      ? <mark key={i} className="rounded bg-amber-200/70 px-0.5 font-semibold text-slate-900">{part}</mark>
      : part);
}
